/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiCoilChannelHistoryModel } from '../../models/api-coil-channel-history-model';

export interface GetCoilHistory$Params {
  coilSerialNumber: number;
  coilMaterialNumber: string;
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function getCoilHistory(http: HttpClient, rootUrl: string, params: GetCoilHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiCoilChannelHistoryModel>>> {
  const rb = new RequestBuilder(rootUrl, getCoilHistory.PATH, 'get');
  if (params) {
    rb.path('coilSerialNumber', params.coilSerialNumber, {});
    rb.path('coilMaterialNumber', params.coilMaterialNumber, {});
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiCoilChannelHistoryModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getCoilHistory.PATH = '/api/CoilAsync/coilhistory/{coilSerialNumber}/{coilMaterialNumber}/{systemSerialNumber}/{systemMaterialNumber}';
getCoilHistory.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getCoilHistory.ROOTURL = '/coil';
